import colors from "@faire/slate/foundation/color/semantic";

export const buildSlateColorTokens = () => {
  const tokens = new Map<string, { name: string; value: string }>();

  const toVarKey = (
    paletteKey: string,
    styleKey: string,
    colorKey: string,
    subColorKey?: string
  ) => {
    const isCore = paletteKey.toLowerCase() === "core";
    const parts = isCore
      ? [styleKey, colorKey, subColorKey].filter(Boolean)
      : [paletteKey, styleKey, colorKey, subColorKey].filter(Boolean);
    return `slate-color-${parts.join("-")}`.toLowerCase();
  };

  Object.entries(colors).forEach(([paletteKey, paletteValue]) => {
    Object.entries(paletteValue).forEach(([styleKey, styleValue]) => {
      Object.entries(styleValue).forEach(([colorKey, colorValue]) => {
        if (colorValue && typeof colorValue === "object") {
          Object.entries(colorValue).forEach(([subColorKey, subColorValue]) => {
            const varKey = toVarKey(
              paletteKey,
              styleKey,
              colorKey,
              subColorKey
            );
            if (!tokens.has(varKey)) {
              tokens.set(varKey, {
                name: `${paletteKey}.${styleKey}.${colorKey}.${subColorKey}`,
                value: `var(--${varKey}, ${subColorValue})`,
              });
            }
          });
        } else {
          const varKey = toVarKey(paletteKey, styleKey, colorKey);
          if (!tokens.has(varKey)) {
            tokens.set(varKey, {
              name: `${paletteKey}.${styleKey}.${colorKey}`,
              value: `var(--${varKey}, ${colorValue})`,
            });
          }
        }
      });
    });
  });

  return Array.from(tokens.values());
};
